'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
import { memo } from 'react';
const RiskDisclosureLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-[120px] w-[100%] rounded-[20px]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(RiskDisclosureLoading);